import React, { useEffect, useState, useContext } from 'react';
import { getLogsStudent } from '../../services/ClassroomServices';
import { FaMapMarkerAlt, FaCheckSquare, FaKeyboard } from 'react-icons/fa';
import { ClassroomContext } from '../../context/ClassroomContext';
import AuthContext from '../../context/AuthContext';
import styles from './styles/ClassroomGrades.module.css';
import ClassroomSearchSidebar from './ClassroomSearchSidebar';

const ClassroomGrades = () => {
    const { classroom } = useContext(ClassroomContext);
    const { userId } = useContext(AuthContext);
    const [data, setData] = useState([]);
    const [expandedView, setExpandedView] = useState(null);
    const [selectedAssignment, setSelectedAssignment] = useState(null);

    const handleClickView = (id) => {
        setExpandedView(prev => (prev === id ? null : id));
    };

    useEffect(() => {
        const getLogs = async () => {
            const data = await getLogsStudent(classroom._id, userId);
            setData(data);
        };
        getLogs();
    }, [classroom, userId]);

    const getDecisionClass = (decision) => {
        const classes = [styles.decisionItem];
        if (decision.type === 'choice' || decision.type === 'input') {
            if (decision.correctness === 'correct') {
                classes.push(styles.correct);
            } else if (decision.correctness === 'incorrect') {
                classes.push(styles.incorrect);
            }
        }
        return classes.join(' ');
    };

    const filteredData = Object.entries(data).filter(([key, info]) => {
        if (!selectedAssignment) return true;
        return selectedAssignment._id === key;
    });

    return (
        <div className={styles.container}>
            <div className={styles.pageContainer}>
                <div className={styles.mainContent}>
                    {filteredData.length === 0 ? (
                        <p className={styles.noLogs}>No logs to display for this assignment.</p>
                    ) : (
                        filteredData.map(([key, info]) => (
                            <div key={key} className={styles.assignmentSection}>
                                <h2 className={styles.assignmentTitle}>{info.assignmentTitle}</h2>
                                {info.logs
                                    .sort((a, b) => new Date(b.updatedAt) - new Date(a.updatedAt))
                                    .map((log, index) => (
                                        <div key={log._id} className={styles.logBlock}>
                                            <p
                                                onClick={() => handleClickView(log._id)}
                                                className={styles.logItem}
                                            >
                                                Attempt {info.logs.length - index} —{' '}
                                                {log.grade ? `${log.grade}%` : 'Ungraded'}
                                            </p>

                                            {expandedView === log._id && (
                                                log.decisions.length > 0 ? (
                                                    <ul className={styles.decisionList}>
                                                        {log.decisions
                                                            .filter(dec => dec.priority)
                                                            .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
                                                            .map((decision, idx) => (
                                                                <li
                                                                    key={decision._id || idx}
                                                                    className={getDecisionClass(decision)}
                                                                >
                                                                    {decision.type === 'situation' && (
                                                                        <>
                                                                            <FaMapMarkerAlt className={styles.decisionIcon} />
                                                                            <span>Question: {decision.title || 'untitled'}</span>
                                                                        </>
                                                                    )}
                                                                    {decision.type === 'choice' && (
                                                                        <>
                                                                            <FaCheckSquare className={styles.decisionIcon} />
                                                                            <span>Choice: {decision.title || 'untitled'}</span>
                                                                        </>
                                                                    )}
                                                                    {decision.type === 'input' && (
                                                                        <>
                                                                            <FaKeyboard className={styles.decisionIcon} />
                                                                            <span>Input: "{decision.userInput}"</span>
                                                                        </>
                                                                    )}
                                                                </li>
                                                            ))}
                                                    </ul>
                                                ) : (
                                                    <div className={styles.noDecisions}>
                                                        No decisions recorded in this log.
                                                    </div>
                                                )
                                            )}
                                        </div>
                                    ))}
                            </div>
                        ))
                    )}
                </div>
                <div className={styles.sidebar}>
                    <ClassroomSearchSidebar
                        classroomId={classroom._id}
                        setSelectedAssignment={setSelectedAssignment}
                    />
            </div>
            </div>
        </div>
    );
};

export default ClassroomGrades;
